import { Fragment, ReactNode } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import classNames from 'classnames';

import { MenuAlignment, MenuButtonItem } from './types';

type HeaderMenuButtonProps = {
  trigger: ReactNode;
  items: Array<MenuButtonItem>;
  menuAlignment?: MenuAlignment;
};

export const HeaderMenuButton = ({ trigger, items, menuAlignment = 'right' }: HeaderMenuButtonProps) => {
  return (
    <div className="relative text-gray-600 focus-visible:outline-none">
      <Menu>
        <MenuButton className="flex w-full items-center focus-visible:outline-none">
          <div
            className={classNames(
              'group text-left text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-gray-100',
            )}
          >
            {trigger}
          </div>
        </MenuButton>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems
            className={classNames(
              'absolute overflow-hidden z-[500] mt-1 origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 cursor-pointer focus-visible:outline-none',
              menuAlignment === 'right' ? 'right-0' : 'left-0',
            )}
          >
            {items.map(({ value, onClick }) => (
              <MenuItem key={value}>
                <button className="w-36 text-left hover:bg-gray-200" onClick={onClick}>
                  <div className="px-4 py-2 text-sm text-gray-700">{value}</div>
                </button>
              </MenuItem>
            ))}
          </MenuItems>
        </Transition>
      </Menu>
    </div>
  );
};
